import { useState, useEffect } from 'react';
import { ReadingsService } from 'src/services/readings/readings.service';
import { useAuthentication } from 'src/features/authentication/context';

type Item = {
  id: string;
  assignedAlarmTagId?: string | null;
  assignedAlarmGatewayId?: string | null;
};

type Props = {
  items?: Item[];
};

export const useGetMultipleLatestReadings = ({ items }: Props) => {
  const {
    customerId: { value: customerId },
  } = useAuthentication();
  const [readingsMap, setReadingsMap] = useState<Record<string, any>>({});
  const [isDataReady, setIsDataReady] = useState(false);

  useEffect(() => {
    const fetchAllReadings = async () => {
      if (!items || items.length === 0) {
        setIsDataReady(true);
        return;
      }

      const validItems = items.filter(
        (item) => !!item.assignedAlarmGatewayId && !!item.assignedAlarmTagId
      );

      if (validItems.length === 0) {
        setIsDataReady(true);
        return;
      }

      const promises = validItems.map((item) =>
        ReadingsService.getLatestReadingsNewDataStorage({
          customerId: customerId!,
          gatewayId: item.assignedAlarmGatewayId as string,
          measurements: item.assignedAlarmTagId as string,
        })
          .then((res) => {
            if (res === null) {
              return null;
            }

            return {
              id: item.id,
              data: res.data,
            };
          })
          .catch((error) => {
            console.error(`Error fetching data for item ${item.id}`, error);
            return null;
          })
      );

      const results = await Promise.all(promises);

      const dataMap: Record<string, any> = {};
      results.forEach((result) => {
        if (result) {
          dataMap[result.id] = result.data;
        }
      });

      setReadingsMap(dataMap);
      setIsDataReady(true);
    };

    fetchAllReadings();
  }, [items, customerId]);

  return { readingsMap, isDataReady };
};
